/* eslint-disable */
import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import {
  Field,
  FieldArray,
  reduxForm,
  change,
  unregisterField,
} from 'redux-form'
import styles from './TkAndCrpForms.css'
import { checkTKFeatureEnabled, checkCRPFeatureEnabled } from '../../../configs'
import pluseIcon from 'static/images/Vector.png'
import Typography from '@material-ui/core/Typography'
import FormSection from '../../../views/components/Common/FormSection/FormSection'
import { Box } from '@material-ui/core'
import { LICENSE_COVERED_AREAS,LICENSE_COVERED_EU_REGION_COUNTRIES, getRegion } from 'legacy/constants'

const LicensedAreasCovered = props => {
  const dispatch = useDispatch()
  const [ states, setStates ] = useState([])
  const isUsRegion = getRegion() ==='us'
  const {
    me,
    CoveredStateData
  } = props

  // Constants to check telekardia enabled and user is admin or not
  const tkEnabled = checkTKFeatureEnabled(me)
  const crpEnabled = checkCRPFeatureEnabled(me)
  const Name = me && me.data && me.data.teams && me.data.teams[0].name


  useEffect(() => {
    if (CoveredStateData) {
      const answer = (isUsRegion?LICENSE_COVERED_AREAS:LICENSE_COVERED_EU_REGION_COUNTRIES).filter(item => (
        CoveredStateData.includes(item.code)
      )).map(item => item.name)
      setStates(answer)
    }
  }, [ CoveredStateData ])

  const areaStyles = {
    width: '223px',
    color: '#142A39',
    fontSize: '16px',
    fontFamily: 'Work Sans',
    fontStyle: 'normal',
    fontWeight: '400',
  }

  return (
    <form className={styles.updatePasswordForm}>
      {
        <React.Fragment>
          {(tkEnabled || crpEnabled) && (
            <React.Fragment>
              <FormSection heading="Covered States">
                <div className={styles.formSectionRow} style={{ width: '100%', justifyContent: 'unset' }}>
                  <Box flex flexDirection="colum" style={{ width: '100%' }}>
                    <Typography variant="body1" className={styles.appointmentText}>
                      {`${Name} covers the following states:`}
                    </Typography>
                    <Box style={{ display: 'flex', flexFlow: 'column-wrap', maxHeight: '345px' }}>
                      <ul style={{ maxHeight: '270px', display: 'flex', flexDirection: 'column', flexWrap: 'wrap', listStyle: 'disc' }}>
                        {states.map((name, index) => (<li key={index} style={areaStyles}>{name}</li>))}
                      </ul>
                    </Box>
                  </Box>
                </div>
              </FormSection>
            </React.Fragment>
          )}
        </React.Fragment>
      }
    </form>
  )
}

export default reduxForm({
  form: 'licensedAreasCovered',
  enableReinitialize: true,
  destroyOnUnmount: false,
})(LicensedAreasCovered)



// WEBPACK FOOTER //
// ./src/legacy/containers/Forms/LicensedAreasCovered.jsx